const styles = (theme) => ({
  pickupHeaderMenuIconStyles: {
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    width : "100%"
  },
  iconLabel: {
    fontSize: theme.headerTextFontSize
  },
  enabledIcon: {
    cursor: 'pointer'
  },
  iconLayout: {
    float: 'left',
    color: theme.iconColor,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  noFreightIcon: {
    fontSize: theme.textFontSize,
    height: 24,
    fontWeight: 600
  },
  disableIcon: {
    cursor: 'not-allowed',
    opacity: 0.7
  },
  headerIconStyles: {
    padding: "10px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
  },
});

export default styles;
